import { useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import * as queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useIsPreliminaryAuth } from 'utils/hooks/useIsPreliminaryAuth';
import {
  PROVIDER_URL_SEARCH_PARAM,
  PARTNER_URL_SEARCH_PARAM,
} from 'utils/constants/urlSearchParameters';
import { serverStatusActions } from 'utils/actions/serverStatus';
import { authenticationActions } from 'components/Authentication/actions';
import { providerActions } from 'modules/provider/actions';
import { commonActions } from 'utils/actions/common';

export const useBootstrap = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useIsPreliminaryAuth();
  const location = useLocation();

  // didMount
  useEffect(() => {
    const actionsToDispatch = [];
    const queueActionToDispatch = (action) => {
      actionsToDispatch.push(action);
    };

    // it is mandatory to call as it checks access token validity; to avoid locking the user in a loop
    queueActionToDispatch(serverStatusActions.checkServerStatus());

    if (isLoggedIn) {
      queueActionToDispatch(authenticationActions.getUser());
    }

    const {
      [PARTNER_URL_SEARCH_PARAM]: partner,
      int: isInternal,
      [PROVIDER_URL_SEARCH_PARAM]: providerSearchParam,
    } = queryString.parse(location.search);

    if (partner) {
      queueActionToDispatch(authenticationActions.setPartner(partner));
    }

    if (isInternal) {
      queueActionToDispatch(authenticationActions.setInternal());
    }

    if (providerSearchParam) {
      // may not match to store.provider as it replaced with provider obtained from auth user
      window._provider = providerSearchParam;
      // must be set before we call getConfiguration
      queueActionToDispatch(providerActions.setProvider(providerSearchParam));
    }

    if (document.referrer) {
      queueActionToDispatch(commonActions.setCameFrom(document.referrer));
    }

    if (location.pathname || location.search) {
      queueActionToDispatch(commonActions.setUrlParameters(`${location.pathname}${location.search}`));
    }

    batch(() => {
      actionsToDispatch.forEach((action) => {
        dispatch(action);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
